import "./index.css";
import { FiInstagram, FiMail } from "react-icons/fi";

const SOCIALS = [
  { icon: <FiInstagram size={18} />, href: "#", label: "Instagram" },
  { icon: <FiMail size={18} />, href: "#", label: "Email" },
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__inner">
        {/* Left Side: Navigation */}
        <div className="footer__group">
          <nav className="footer__nav">
            <a href="/privacy" className="footer__link">
              Privacy Policy
            </a>
            <span className="footer__divider">/</span>
            <a href="/terms" className="footer__link">
              Terms of Use
            </a>
          </nav>
        </div>

        {/* Right Side: Socials & Copyright */}
        <div className="footer__group">
          <div className="footer__socials">
            {SOCIALS.map(({ icon, href, label }) => (
              <a
                key={label}
                href={href}
                className="footer__social-icon"
                aria-label={label}
              >
                {icon}
              </a>
            ))}
          </div>
          <p className="footer__copyright">
            © {new Date().getFullYear()} Habitime
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
